export const paths = {
    NOT_FOUND: '/404',
    MAIN: '/',
    DOCUMENT_LIST: '/sharing-document/:user_sub',
};

export const publicPages = {
    main: paths.MAIN,
    not_found: paths.NOT_FOUND,
};

export const WIDTH_INSPECTOR = 300;

export const HEIGHT_PICT_VIEW = 84;
